import React, { useState } from "react";
import { CameraIcon, CloseIcon, SimulationIcon } from "../../Icons";
import CustomSelect from "../common/CustomSelect";
import myLocation from "../../assets/icons/my_location.svg";
import mapImg from "../../assets/img/map.png";

export default function KeyMapDrawer({
  setIsExpandMap,
  isExpandMap,
  setActiveTool,
}) {
  const [isShowSimulation, setIsShowSimulation] = useState(false);
  const [isShowCctv, setIsShowCctv] = useState(false);
  const [building, setBuilding] = useState("Turbine");
  const [floor, setFloor] = useState(431);
  return (
    <div>
      {" "}
      {/* header  */}
      <div className="bg-white py-[5px] pl-4 md:pl-5 pr-2 md:pr-2.5 flex items-center justify-between gap-4 relative z-[3]">
        <h6 className="text-[#242424] text-[12px] font-bold">
          {" "}
          {isExpandMap ? "Monitoring" : "Key map"}{" "}
        </h6>
        <button onClick={() => setActiveTool("")}>
          <CloseIcon color="#242424" />
        </button>
      </div>
      <div className="pl-4 md:pl-5 p-2 bg-[#EAEAEA] flex items-center justify-between gap-2 flex-wrap">
        {/* left side  */}
        <div className="max-w-[287px] w-full flex items-center gap-4 md:gap-5">
          <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
            <p className="text-[11px] text-[#242424] font-medium">건물</p>
            <CustomSelect
              label="Turbine"
              value={building}
              options={["Turbine", "Turbine1", "Turbine2"]}
              onSelect={(val) => setBuilding(val)}
              className="text-left"
              isSearching={true}
            />
          </div>
          <div className="min-w-[90px] flex-1 w-full grid grid-cols-[21px_1fr] gap-2.5 items-center">
            <p className="text-[11px] text-[#242424] font-medium">층</p>
            <CustomSelect
              label="층"
              value={floor}
              options={[431, 433, 432]}
              onSelect={(val) => setFloor(val)}
              className="text-left"
              isSearching={true}
            />
          </div>
        </div>
        {/* right side  */}
        <div className="flex items-center gap-2">
          <button
            className={`w-7 aspect-square  rounded-[6px] flex justify-center items-center ${
              isExpandMap ? "bg-red-300" : "bg-white"
            }`}
            onClick={() => setIsExpandMap(!isExpandMap)}
          >
            <img src={myLocation} alt="" />
          </button>
          <button
            className={`w-7 aspect-square  rounded-[6px] flex justify-center items-center ${
              isShowSimulation ? "bg-[#08F]" : "bg-white"
            }`}
            onClick={() => setIsShowSimulation(!isShowSimulation)}
          >
            <SimulationIcon color={isShowSimulation ? "#fff" : "#000"} />
          </button>
          <button
            className={`w-7 aspect-square  rounded-[6px] flex justify-center items-center ${
              isShowCctv ? "bg-[#FF9500]" : "bg-white"
            }`}
            onClick={() => setIsShowCctv(!isShowCctv)}
          >
            <CameraIcon color={isShowCctv ? "#fff" : "#000"} />
          </button>
        </div>
      </div>
      <div className="p-2.5 flex items-center justify-center cursor-pointer">
        <div className="w-fit h-fit relative">
          <img src={mapImg} alt="" />
          {/* Camera  */}
          {isShowCctv && (
            <>
              {" "}
              {/* camera1  */}
              <div
                className="w-8 aspect-square rounded-full bg-[#FF9500] absolute top-[14%] left-[44%] flex items-center justify-center "
                style={{
                  filter: "drop-shadow(0 5px 8px rgba(255, 149, 0, 0.25))",
                }}
              >
                <CameraIcon color="#fff" />
              </div>
              {/* camera2  */}
              <div
                className="w-8 aspect-square rounded-full bg-[#FF9500] absolute top-[38.5%] right-[28%] flex items-center justify-center "
                style={{
                  filter: "drop-shadow(0 5px 8px rgba(255, 149, 0, 0.25))",
                }}
              >
                <CameraIcon color="#fff" />
              </div>
            </>
          )}
          {/* simulation  */}
          {isShowSimulation && (
            <>
              <div
                className="w-8 aspect-square rounded-full bg-[#08F] absolute top-[42.5%] left-[31.25%] flex items-center justify-center "
                style={{
                  filter: "drop-shadow(0 5px 8px rgba(0, 136, 255, 0.25))",
                }}
              >
                <SimulationIcon color="#fff" />
              </div>
              {/* simulation2  */}
              <div
                className="w-8 aspect-square rounded-full bg-[#08F] absolute bottom-[22.5%] right-[35.25%] flex items-center justify-center "
                style={{
                  filter: "drop-shadow(0 5px 8px rgba(0, 136, 255, 0.25))",
                }}
              >
                <SimulationIcon color="#fff" />
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
